import { Validators } from "@angular/forms";

export const MAKE_UP_EXAM_CONTROLS = {
    options                   :   [, { validators: [Validators.required], updateOn: 'change' }],
    makeUpExamReason          :   [, { updateOn: 'change' }],
};
